export const ERA_DURATION = new Date(21600000)